import { useQuery } from '@tanstack/react-query';
import { Card, Spin, Typography, Empty, Image, Button } from 'antd';
import axios from '../../config/axios';
import { useNavigate } from 'react-router-dom';
import { ArrowLeftOutlined, QrcodeOutlined } from '@ant-design/icons';

const { Text } = Typography;

interface QRCodeResponse {
	qr_code: string | null;
}

const QRCode = () => {
	const navigate = useNavigate();

	const { data, isLoading, error } = useQuery({
		queryKey: ['qr-code'],
		queryFn: async () => {
			const response = await axios.get('/public/fundamentals/get-qr-code');
			return response.data.results as QRCodeResponse;
		},
	});

	return (
		<div className="mx-auto max-w-lg px-4 py-8">
			<Card
				className="overflow-hidden rounded-xl shadow-md"
				title={
					<div className="flex w-full items-center justify-between">
						<div className="flex items-center gap-2">
							<QrcodeOutlined className="text-xl text-primary" />
							<span className="text-xl font-bold">Device Enrollment</span>
						</div>
						<Button
							icon={<ArrowLeftOutlined />}
							onClick={() => navigate(-1)}
							type="default"
							className="flex items-center"
						>
							Back
						</Button>
					</div>
				}
			>
				{isLoading ? (
					<div className="flex justify-center py-12">
						<Spin size="large" />
					</div>
				) : error ? (
					<div className="py-8 text-center">
						<Text type="danger">Failed to load QR code. Please try again later.</Text>
					</div>
				) : !data?.qr_code ? (
					<Empty
						description="No QR code available at the moment"
						className="py-8"
					/>
				) : (
					<div className="flex flex-col items-center py-6">
						<Image
							src={data.qr_code}
							alt="Device Enrollment QR Code"
							className="mb-4 rounded border"
							width={240}
						/>
						<Text className="mt-4 text-center">Scan this QR code to enroll your device</Text>
					</div>
				)}
			</Card>
		</div>
	);
};

export default QRCode;
